import { ApiResult } from 'interfaces/APITypes';

import { makeRequest, mytoverInstance } from './client';

export const getKpis = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/kpi'));
};
